export enum RateTypes {
  INTEREST_RATE = 'interestRate',
  COMPARISON_RATE = 'comparisonRate',
  PAYMENT_TERM = 'paymentTerm',
  DEPOSIT_PERCENTAGE = 'depositPercentage',
  UPFRONT_PAYMENT = 'sticky_footer_upfront_payment_label',
}
